<template>
  <div class="booth">
    <img src="~@/assets/image/common/common_booth.png" alt="">
    <div class="message">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: "emptyContent",
  props: ['text']
};
</script>

<style scoped lang='less'>
.booth{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 70vh;
  img{
    width: 2.773333rem;
  }
  .message{
    font-size: .4rem;
    margin-top: .666667rem;
    color: #B9BED1;
  }
}
</style>
